/* EVENTS INVOLVING AI FOT */

export default {
  ai_page_viewed: {
    excludeSuperAdmin: true,
    getProps: ({ page_name, student_id, student_id_db }) => {
      return {
        page_name: page_name,
        ...(student_id ? { student_id: student_id } : {}),
        ...(student_id_db ? { student_id_db: student_id_db } : {}),
      };
    },
  },
  ai_action_triggered: {
    excludeSuperAdmin: true,
    getProps: ({ action_name, student_id, student_id_db }) => {
      return {
        action_name: action_name,
        ...(student_id ? { student_id: student_id } : {}),
        ...(student_id_db ? { student_id_db: student_id_db } : {}),
      };
    },
  },
};
